export default __webpack_public_path__ + "static/media/downloadIOS.aedfd199.webp";